"use client"
import Cookies from 'js-cookie';
import api from '@utils/api';
import { key } from '@utils/token';
import styles from './chart.module.css';
import moment from 'moment-jalaali';




// import { Button, Col, Container, Row } from "react-bootstrap";
import { ChartingLibraryWidgetOptions, LanguageCode, ResolutionString, widget } from "@lib/charting_library";
import { ToastContainer, toast } from 'react-toastify';
let changeCounter = 0;

import { useOnClickOutside } from 'usehooks-ts'

import hmacSHA256 from "crypto-js/hmac-sha256";
import { useEffect, useRef, useState, useCallback, memo, useContext } from "react";
import { useColorScheme } from "@components/useColorScheme";

import useExportExcel from "@components/useExportExcel";


//bar replay variables
var ac;
let subscriptions;
var replay_current_pos = 0;
var cc = [];
var main_timer;
let state = {};
let state_end = 0;
let cc_length = 0;
let vcount;

let state_data = [];

let replay_latest_bars = []
let latest_bars = {}

let onRealtimeCallback_ = null
let autoSaveDelay = 10000;
let time = null;
let replayTimer = null;
let lastBarTime = null;

const autoSaveConf = 1;
import { ChartContext } from "@contexts/ChartContext";

const tvCandleTypes = [
  "Bar", "Candle", "Line", "Area", "Renko", "Kagi", "Line Break", "Heikin-Ashi", "Hollow Candle", "Baseline", "Hi-Lo", "Column"]



export const TVChart = memo((props) => {
  const {
    currentCandle,
    setCurrentCandle,
    currentSymbol,
    setCurrentSymbol,
    symbols,
    setSymbols,
    symbolsID,
    setSymbolsID,
    layouts,
    setLayouts,
    selectedChart,
    setSelectedChart,
    tvWidgetsComp,
    setTvWidgetsComp,
    widgets,
    setWidgets,
    mainWidget,
    setMainWidget,
    selectedInterval,
    setSelectedInterval,
    replayMode,
    tvWidgetsCompReady,
    permittedToLoad,
    setTvWidgetsCompReady,
    setReplayMode,
    activeWatcherIndex,
    setActiveWatcherIndex,
    allMarketWatcher,
    setAllMarketWatcher,
    allTvWidgetsCompReady,
    setAllTvWidgetsCompReady,
    t,
    isScriptReady,
    watcherOpen,
    setIsScriptReady,
    templateLoaded,
    setTemplateLoaded,
    setPhoneSidebarOpen,
    adjustedTypes,
    autoSaveConf, setAutoSaveConf,
    phoneSidebarOpen
  } = useContext(ChartContext);


  const exportExcel = useExportExcel(mainWidget);




  const tv_key = key();
  const container = useRef([]);

  const datafeed_prefix = `https://tradingview.sourcearena.ir/mix/${tv_key}`;





  const checkTime = () => {

    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const day = now.getDay();

    const startTime = { hours: 9, minutes: 0 };
    const endTime = { hours: 12, minutes: 30 };
    const excludedDays = [4, 5];

    const isWithinTimeRange =
      (hours > startTime.hours || (hours === startTime.hours && minutes >= startTime.minutes)) &&
      (hours < endTime.hours || (hours === endTime.hours && minutes <= endTime.minutes));

    if (isWithinTimeRange && !excludedDays.includes(day)) {
      return true;
    }

    return false;
  }

  const bar_replay = useRef(null);

  const exit_replay_mode = useRef(null);
  const playOrStop = useRef(null);
  const bar_replay_controls = useRef(null);
  const bar_replay_step = useRef(null);
  const bar_replay_speed = useRef(null);
  const bar_replay_step_state = useRef(null);

  const [bar_replay_controls_status, set_bar_replay_controls_status] = useState(false);
  const [bar_step_controls_status, set_bar_step_controls_status] = useState(false);




  const replayUIMounted = useRef(false);
  const adjustedDP = useRef(false);
  const bar_replay_controls_state = useRef(null);
  const [toSaveData, setToSaveData] = useState({});
  const [toSaveAllData, setToSaveAllData] = useState({});
  const { isDark, setIsDark } = useColorScheme();


  const [firstLoadChart, setFirstLoadChart] = useState(true);
  const [isFirstTemplateLoad, setIsFirstTemplateLoad] = useState(true);
  const [isReplaying, setIsReplaying] = useState(false);
  const [replay_to, set_replay_to] = useState(null);


  const [replay_from, set_replay_from] = useState(null);
  const [tvWidgets, setTvWidgets] = useState([]);
  const [showSelectSpeed, setShowSelectSpeed] = useState(false);
  const [selectedReplaySpeed, setSelectedReplaySpeed] = useState("1x");

  const [widgetPos, setWidgetPos] = useState(1);
  const [loadedChart, setLoadedChart] = useState("SAVE CHART");
  const [selectedBar, setSelectedBar] = useState(1);
  const [saveBtnPressed, setSaveBtnPressed] = useState(0);
  const [savePreBtnPressed, setPreSaveBtnPressed] = useState(0);
  const jMonths = [
    "فروردین",
    "اردیبهشت",
    "خرداد",
    "تیر",
    "مرداد",
    "شهریور",
    "مهر",
    "آبان",
    "آذر",
    "دی",
    "بهمن",
    "اسفند",
  ];
  const uploadTemp = useRef(null);



  const replaySpeeds = {
    "1x": 1000,
    "10x": 100,
    "100x": 10,
  }

  const changeAdjustedType = useCallback((type) => {
    if (mainWidget) {
      setShowAdjustedDP(0)

      setAdjustedType(type)

      if (type == 1) {
        setAdjustedText("تعدیل شده")
      } else {
        setAdjustedText("تعدیل نشده")
      }




      mainWidget.onChartReady(() => {
        const [s_symbol, s_type] = currentSymbol.split("|")
        console.log("set Adjusted", `${s_symbol}|${type}`)
        setCurrentSymbol(s_symbol);


        let new_adjusted = [...adjustedTypes.current]
        new_adjusted[selectedChart] = type;
        adjustedTypes.current = new_adjusted
        setSymbols(prevSymbols => {
          const updated = [...prevSymbols];
          updated[selectedChart] = `${s_symbol}|${type}`;
          return updated;
        });



        setTimeout(() => { mainWidget.load() }, 200)


      })



    }

  }, [mainWidget])
  const redoTV = () => { mainWidget.activeChart().executeActionById("redo") }
  const undoTV = () => { mainWidget.activeChart().executeActionById("undo") }

  const settingTV = () => { mainWidget.activeChart().executeActionById("chartProperties") }
  const compareTV = () => { mainWidget.activeChart().executeActionById("compareOrAdd") }
  const searchTV = () => { mainWidget.activeChart().executeActionById("symbolSearch") }


  const indicatorTV = () => { mainWidget.activeChart().executeActionById("insertIndicator") }
  const openPhoneMenu = () => { setPhoneSidebarOpen(!phoneSidebarOpen) }

  function toggleFullscreen() {
    var isFullscreen = document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || false;

    if (isFullscreen) {
      exitFullscreen();
    } else {
      enterFullscreen();
    }
  }

  function enterFullscreen() {
    var element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    }
  }

  function exitFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    }
  }







  const [showMultiChart, setShowMultiChart] = useState(false);
  const [isReadyToAutoSave, setIsReadyToAutoSave] = useState(false);
  const [showSaveChart, setShowSaveChart] = useState(false);
  const [showAdjustedDP, setShowAdjustedDP] = useState(false);
  const [adjustedType, setAdjustedType] = useState(1);
  const [adjustedText, setAdjustedText] = useState("تعدیل شده");


  const multiCahrtDP = useRef(null);
  const saveCahrtDP = useRef(null);
  const barReplaySpeedItem = useRef(null);

  const candleDP = useRef(null);
  const timeFrameDP = useRef(null);

  useEffect(() => {


    if (isReplaying && replayMode) {

      let replayTimer = setInterval(() => {


        try {


          let data = latest_bars[currentSymbol].filter(item => item.time > time)[0]

          if (data) {
            onRealtimeCallback_(data);
            time = data.time

          } else {
            setIsReplaying(false)
            bar_replay_controls_state.current.innerHTML = `<svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6"><path   fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path></svg>`
            bar_replay_controls.current.setAttribute('title', 'Play');
          }
        } catch (e) {
          console.log("playong 000 e", e)
        }


      }, replaySpeeds[selectedReplaySpeed])

      return () => {
        clearInterval(replayTimer)
      }
    }

  }, [currentSymbol, selectedReplaySpeed, isReplaying, replayMode]);



  const exitReplayMode = useCallback(() => {
    setIsReplaying(false)
    setReplayMode(false)
    set_replay_to(null)
    set_replay_from(null)
    setTvWidgetsCompReady(false)

    mainWidget.onChartReady(() => {
      mainWidget.loadChartFromServer({ id: "single@" + currentSymbol })


    })
    bar_replay_step.current.style.display = "none"
    bar_replay_speed.current.style.display = "none"
    exit_replay_mode.current.style.display = "none"
    bar_replay_controls.current.style.display = "none"
    setAllTvWidgetsCompReady(false)
    setTvWidgetsCompReady(false)


  }, [mainWidget, setTvWidgetsCompReady, setAllTvWidgetsCompReady, currentSymbol])



  const startReplayMode = useCallback(() => {



    if (replayMode) {
      toast.error(t("You are already in replay mode, exit replay mode and try again"))

      return
    }
    else if (mainWidget.activeChart().chartModel().
      mainSeries().isLoading() == false) {


      ac = [...mainWidget.activeChart().chartModel().mainSeries().bars()._items]

      replay_current_pos = 0


      playOrStop.current.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg"  className="w-6 h-6" viewBox="0 0 28 28" width="28" height="28"><path fill="none" stroke="currentColor" d="M13.5 20V9l-6 5.5 6 5.5zM21.5 20V9l-6 5.5 6 5.5z"></path></svg>'

      mainWidget.activeChart().requestSelectBar().then((time) => {


        set_replay_to(time + 86400)
        set_replay_from(mainWidget.activeChart().getVisibleRange().from)
        setReplaySymbol(mainWidget.activeChart().symbolExt().symbol)
        setReplayMode(true);





        if (mainWidget.activeChart().isSelectBarRequested()) {
          mainWidget.activeChart().cancelSelectBar();


          bar_replay_status = 0
        }

        replayUIMounted.current = false;

      }).catch(function (err) {
        console.log(err)
        toast.error(t("You are already in replay mode"))
      });

    } else {
      toast.error(t("Please wait while chart is loading"))
    }

    return () => {
      try {
        if (mainWidget.activeChart().isSelectBarRequested()) {

          mainWidget.activeChart().cancelSelectBar()
        }

      } catch (e) {
        //console.log("cancelSelectBar", e)

      }
    }






  }, [replayMode, mainWidget, t])


  const setTheme = useCallback((theme) => {
    if (tvWidgetsCompReady) {


      setIsDark(theme);

      tvWidgetsComp.map(item => {
        item.changeTheme(!theme ? "Dark" : "Light").then(() => {
          if (theme) {
            item.applyOverrides({
              "paneProperties.background": "#ffffff",
              "paneProperties.backgroundType": "solid",
              "scalesProperties.textColor": "#0a1229"

            });
          } else {
            item.applyOverrides({
              "paneProperties.background": "#0a1229",
              "scalesProperties.textColor": "#ffffff",

              "paneProperties.backgroundType": "solid",

            });

          }
        })


      });
    }


  }, [tvWidgetsCompReady])


  const [openSaveDialogSignal, setOpenSaveDialogSignal] = useState(false);
  useEffect(() => {
    let dialog = null;
    if (openSaveDialogSignal && mainWidget) {
      dialog = setInterval(() => {
        mainWidget?.onChartReady(() => {
          mainWidget?.showSaveAsChartDialog();
          setOpenSaveDialogSignal(false)
        })
      }, 200)
    }
    return () => {
      if (openSaveDialogSignal && dialog) {
        clearInterval(dialog)
      }
    }
  }, [openSaveDialogSignal, mainWidget])



  useOnClickOutside(multiCahrtDP, () => { setShowMultiChart(false) })
  useOnClickOutside(saveCahrtDP, () => { setShowSaveChart(false) })
  useOnClickOutside(timeFrameDP, () => { setShowSelectInterval(false) })
  useOnClickOutside(candleDP, () => { setShowSelectCandle(false) })


  const barTypes = {
    1: "شمعی",
    0: "میله ای",
    2: "خطی",
    3: "مساحت",
  }
  const barIntervals = {
    60: "1H",
    5: "5m",
    1: "1m",
    //240: "4H",
    "1D": "1D",
    "1W": "1W",
    "1M": "1M",
    "3M": "3M",
    "6M": "6M",
    "12M": "12M",

  }
  const [replaySymbol, setReplaySymbol] = useState("");


  const [showSelectInterval, setShowSelectInterval] = useState(false);
  const [showSelectCandle, setShowSelectCandle] = useState(false);

  const [multiChartActiveIcon, setMultiChartActiveIcon] = useState(`<svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" width="26" height="23"><rect width="22" height="20" fill="none" stroke="currentColor" rx="2" transform="translate(.5 .5)"></rect></svg>`);
  const [barTypeActiveIcon, setBarTypeActiveIcon] = useState(`<svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 28 28" width="28" height="28" fill="currentColor"><path d="M17 11v6h3v-6h-3zm-.5-1h4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5z"></path><path d="M18 7h1v3.5h-1zm0 10.5h1V21h-1z"></path><path d="M9 8v12h3V8H9zm-.5-1h4a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-13a.5.5 0 0 1 .5-.5z"></path><path d="M10 4h1v3.5h-1zm0 16.5h1V24h-1z"></path></svg>`);



  const multiCahrtSVG = [
    `<svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" className="w-6 h-6">
                        <rect width="22" height="20" fill="none" stroke="currentColor" rx="2" transform="translate(.5 .5)"></rect>
                      </svg>`,
    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M11 0v20"></path>
                          </g>
                        </svg>`,


    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M0 10h22"></path>
                          </g>
                        </svg>`,



    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                        <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                          <rect width="22" height="20" rx="2"></rect>
                          <path d="M0 7h22M0 13h22"></path>
                        </g>
                      </svg>`,


    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M7 0v20M15 0v20"></path>
                          </g>
                        </svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M11 0v20M11 10h11"></path>
                          </g>
                        </svg>`,

    `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M0 10h22M11 0v10"></path>
                          </g>
                        </svg>`
  ];


  useEffect(() => {
    setMultiChartActiveIcon(multiCahrtSVG[widgetPos - 1]);
  }, [widgetPos]);
  const multiChartAction = (e, list, pos) => {
    setShowMultiChart(false);
    setWidgets(list)

    setWidgetPos(pos);
    let temp = [...tvWidgets]
    if (pos == 1) {

      temp.indexOf("tv2") > -1 ? temp.splice(tvWidgets.indexOf("tv2")) : 0;
      temp.indexOf("tv3") > -1 ? temp.splice(tvWidgets.indexOf("tv3")) : 0;
      setTvWidgets(temp);
      setTvWidgetsComp((prevWidgets) => prevWidgets.slice(0, 1));
      setSelectedChart(0)


    } else if (pos == 2 || pos == 3) {
      temp.indexOf("tv3") > -1 ? temp.splice(tvWidgets.indexOf("tv3")) : 0;
      setTvWidgets(temp);
      setSelectedChart(1)
      setTvWidgetsComp((prevWidgets) => prevWidgets.slice(0, 2));

    } else {
      setTvWidgets(temp)

    }
  }




  const [iframeExists, setIframeExists] = useState({});


  useEffect(() => {
    const toggleReplayControl = () => {
      set_bar_replay_controls_status(!bar_replay_controls_status)
      if (bar_replay_controls_status) {

        setIsReplaying(true);
        bar_replay_controls.current.setAttribute('title', 'Pause');
        bar_replay_controls_state.current.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6">
            <g fillRule="evenodd">
              <path d="M5 1h1v16H5zM12 1h1v16h-1z"></path>
            </g>
          </svg>`;
      } else {
        setIsReplaying(false);
        bar_replay_controls_state.current.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6">
            <path fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path>
          </svg>`;
        bar_replay_controls.current.setAttribute('title', 'Play');
      }
    };
    const element = bar_replay_controls.current;

    if (element) {
      element.addEventListener("click", toggleReplayControl);
    }

    return () => {
      if (element) {
        element.removeEventListener("click", toggleReplayControl);
      }
    };
  }, [bar_replay_controls_status]);
  useEffect(() => {
    const toggleReplayControl = () => {
      let data = latest_bars[currentSymbol].filter(item => item.time > time)[0]

      if (data) {
        onRealtimeCallback_(data);
        time = data.time

      } else {
        bar_replay_controls_state.current.innerHTML = `<svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6"><path   fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path></svg>`

        bar_replay_controls.current.setAttribute('title', 'Play');

      }

    };
    const element = bar_replay_step.current;

    if (element) {
      element.addEventListener("click", toggleReplayControl);
    }

    return () => {
      if (element) {
        element.removeEventListener("click", toggleReplayControl);
      }
    };
  }, [bar_step_controls_status, currentSymbol]);





  const customDatafeed = {
    onReady: (callback) => {
      setTimeout(() => callback({
        supports_search: true,
        supports_group_request: false,
        supports_marks: false,
        supports_timescale_marks: false,
        supports_time: true,
        supported_resolutions: ['1', '5', '15', '30', '60', 'D'],
      }), 0);
    },

    searchSymbols: async (userInput, exchange, symbolType, onResultReadyCallback) => {
      try {
        // Make API call to fetch matching symbols
        const response = await api.get(`${datafeed_prefix}/search`, {
          params: { query: userInput, exchange, symbolType },
          withCredentials: false,
        });

        const data = response.data;

        // Map API results to TradingView format
        const results = data.map(item => ({
          symbol: item.symbol,          // e.g., "AAPL"
          full_name: item.full_name,    // e.g., "NASDAQ:AAPL"
          description: item.description || item.symbol,
          exchange: item.exchange || "US",
          ticker: item.symbol,
          type: item.type || "stock",
        }));

        // Pass results back to TradingView
        onResultReadyCallback(results);

      } catch (error) {
        console.error("Error searching symbols:", error);
        onResultReadyCallback([]);
      }
    },

    resolveSymbol: async (symbolName, onSymbolResolvedCallback, onResolveErrorCallback) => {
      const response = await api.get(`${datafeed_prefix}/symbols?symbol=${symbolName}`, { withCredentials: false });
      const data = await response.data;
      onSymbolResolvedCallback(data);

    },

    getBars: async (symbolInfo, resolution, periodParams, onHistoryCallback, onErrorCallback) => {

      try {




        let link = `${datafeed_prefix}/bars?type=${symbolInfo.type}&symbol=${symbolInfo.name}|${(adjustedTypes.current[selectedChart]) ?? 0}&resolution=${resolution}&from=${periodParams.from}&to=${periodParams.to}&countback=${periodParams.countBack}`

        if (replayMode) {
          link = `${datafeed_prefix}/bars?type=${symbolInfo.type}&symbol=${symbolInfo.name}|${(adjustedTypes.current[selectedChart]) ?? 0}&resolution=${resolution}&from=${periodParams.firstDataRequest ? (replay_from ?? periodParams.from) : periodParams.from}&to=${periodParams.firstDataRequest ? (replay_to ?? periodParams.to) : periodParams.to}&countback=${periodParams.countBack}`

        }


        const response = await api.get(link, { withCredentials: false });

        const data = await response.data;
        if (data.length) {
          const bars = data.map(el => ({
            time: el.time * 1000,
            low: el.low,
            high: el.high,
            open: el.open,
            close: el.close,
            volume: el.volume,
          }));



          if (Array.isArray(latest_bars[symbolInfo.name])) {
            latest_bars[symbolInfo.name] = [...latest_bars[symbolInfo.name]].reverse().concat([...bars].reverse()).reverse()

          } else {
            latest_bars[symbolInfo.name] = [].concat([...bars].reverse()).reverse()
          }



          if (replayMode && replaySymbol == symbolInfo.name && !replayUIMounted.current) {
            replay_latest_bars = [...replay_latest_bars].reverse().concat([...bars].reverse()).reverse()
            time = replay_to * 1000

            bar_replay_step.current.style.display = ""
            bar_replay_speed.current.style.display = ""
            exit_replay_mode.current.style.display = ""

            bar_replay_controls.current.setAttribute('title', 'Play');
            bar_replay_controls.current.style.display = ""
            bar_replay_controls_state.current.innerHTML = `<svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6"><path   fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path></svg>`

            bar_replay_step_state.current.innerHTML = `<svg   xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="currentColor" className="w-6 h-6"><path   d="M8 14.774L14.5 9 8 3.226zM7 17V1l9 8zM4 1v16h1V1z"></path></svg>`

            bar_replay_step.current.setAttribute('title', 'Forward');


            replayUIMounted.current = true



            set_bar_replay_controls_status(true)
            set_bar_step_controls_status(true)






          }

          onHistoryCallback(bars, { noData: false });
          return Promise.resolve();


        } else {
          onHistoryCallback([], { noData: true });
          return Promise.resolve();

        }
      } catch (error) {
        onErrorCallback(error);
      }
    },



    subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {

      if (replayMode) {

        onRealtimeCallback_ = (data) => {
          if (data) {
            onRealtimeCallback({
              time: data.time,
              low: data.low,
              high: data.high,
              open: data.open,
              close: data.close,
              volume: data.volume,
            });
          }

        }





        return;
      }
      const pollingInterval = 15000;

      const fetchLatestBar = async (res, onRealtimeCallback) => {
        try {


          const response = await api.get(`${datafeed_prefix}/lastBar?type=${symbolInfo.type}&symbol=${symbolInfo.name}&resolution=${res}`, { withCredentials: false });

          const data = await response.data;



          let data_ = {
            low: Math.round(10000 * data.low) / 10000,
            high: Math.round(10000 * data.high) / 10000,
            open: Math.round(10000 * data.open) / 10000,
            close: Math.round(10000 * data.close) / 10000,
          }
          setCurrentCandle((prevState) => ({
            ...prevState,
            [symbolInfo.name + res]: {
              ...prevState[symbolInfo.name + res],
              ...data_,
            },
          }));



          lastBarTime = data.time;
          onRealtimeCallback({
            time: data.time * 1000,
            low: data.low,
            high: data.high,
            open: data.open,
            close: data.close,
            volume: data.volume,
          });
          return Promise.resolve();


        } catch (error) {
          console.error('Error fetching latest bar:', error);
        }

      };


      if (checkTime() || symbolInfo.session == "24x7") {
        fetchLatestBar(resolution, onRealtimeCallback);
      }




      const intervalId = setInterval(() => {
        if (checkTime() || symbolInfo.session == "24x7") {
          fetchLatestBar(resolution, onRealtimeCallback)

        }
      }, pollingInterval);

      subscriptions = subscriptions || {};
      subscriptions[subscribeUID] = intervalId;
    },

    unsubscribeBars: (subscriberUID) => {

      if (subscriptions && subscriptions[subscriberUID]) {
        clearInterval(subscriptions[subscriberUID]);
        delete subscriptions[subscriberUID];
      }
    },


    getMarks: async (symbolInfo, from, to, onDataCallback, resolution) => {
      try {
        const response = await fetch(`https://your-api-endpoint.com/getMarks?symbol=${symbolInfo.name}&from=${from}&to=${to}`);
        const data = await response.json();
        onDataCallback(data);
      } catch (error) {
        console.error('Error fetching marks:', error);
      }
    },

    getTimescaleMarks: async (symbolInfo, from, to, onDataCallback, resolution) => {
      try {
        const response = await fetch(`https://your-api-endpoint.com/getTimescaleMarks?symbol=${symbolInfo.name}&from=${from}&to=${to}`);
        const data = await response.json();
        onDataCallback(data);
      } catch (error) {
        console.error('Error fetching timescale marks:', error);
      }
    },

    getServerTime: (callback) => {
      callback(Math.floor(Date.now() / 1000));
    },
  };


  const saveChart = useCallback(async (showToast = true) => {

    if (tvWidgetsCompReady) {

      console.log("ready to send")

      let content = { helpers: {}, "charts": toSaveData }


      let temp = [];



      try {



        for (let index = 0; index < tvWidgetsComp.length; index++) {
          const item = tvWidgetsComp[index];

          if (item?.activeChart()?.symbolExt().symbol) {
            temp[index] = {
              symbol: item?.activeChart()?.symbolExt().symbol,
              type: adjustedTypes.current[index],
              interval: item?.activeChart()?.resolution(),
              bar: item?.activeChart()?.chartType()
            };
          }
        }



        if (Object.keys(temp).length && toSaveAllData?.content) {

          console.log("to send", content)
          const response = await api.post('/chart/1.3/charts', {
            content: JSON.stringify(content?.charts),

            temp: temp,
            temp_pos: widgetPos,
            tv_temps: widgets,

            name: toSaveAllData?.name?.replace("$autoSave$", ""),
            symbol: toSaveAllData?.symbol,
            resolution: toSaveAllData?.resolution,
          });

          if (!response.data.ok) {
            toast.error(response.data.message);
            console.log('Network response was not ok');
            return null;
          }
          setLoadedChart(toSaveAllData?.name?.replace("$autoSave$", ""));
          loadAllcharts()


          setIsReadyToAutoSave(false)

          if (showToast) {
            uploadTemp.current.style.opacity = "0.5";
            setTimeout(() => { uploadTemp.current.style.opacity = "1"; }, 500);
            toast.success(response.data.message);

          }
          return response.data;
        }
      } catch (e) {
        setIsReadyToAutoSave(false)

      }

      return false;
    }
    setIsReadyToAutoSave(false)

    return false;
  }, [toSaveData, widgets, tvWidgetsComp, widgetPos, tvWidgetsCompReady]);


  useEffect(() => {
    setTimeout(() => { setIsReadyToAutoSave(true) }, autoSaveDelay);

  }, [widgets])

  useEffect(() => {
    if (saveBtnPressed) {
      console.log("save pressed")
      setSaveBtnPressed(0)
      saveChart(false)
    }

  }, [saveBtnPressed])


  useEffect(() => {
    if (isReadyToAutoSave && autoSaveConf) {
      console.log("calliung saveChart from useEffect")
      saveChart(false)
    }

  }, [isReadyToAutoSave, tvWidgetsCompReady])

  useEffect(() => {

    Cookies.set('activeWatcherIndex', activeWatcherIndex, {
      secure: true,
      sameSite: 'strict',
      expires: 7000,
      path: '/',
    });

  }, [activeWatcherIndex])
  const removeChart = async (id) => {
    const response = await api.delete('/chart/1.3/charts/' + id);
    if (!response.data.ok) {
      throw new Error('Network response was not ok');
    }
    return await response.data.ok;
  };
  const loadChart = useCallback(async (id) => {


    console.log(id)
    if (tvWidgetsCompReady) {
      try {
        if (id.includes("single@")) {

          let targetSymbol = id.split("@")[1]
          let content = JSON.parse(layouts[0].content)
          let charts = content.charts



          for (const [symbol, content] of Object.entries(charts)) {
            if (targetSymbol == symbol) {
              return content;
            }
          }
          return null;

        }
      } catch (e) {
        console.log(e)

      }




    }


  }, [tvWidgetsCompReady, layouts])

  const getChartContent = useCallback(async (id) => {

    if (replayMode) {
      return;
    }
    let data_ = "";
    let id_ = "";
    let selectedLayout = layouts[0]


    if (typeof id === "number") {

      selectedLayout = layouts.find(i => i.id == id)
      id_ = id
    } else {
      id_ = id.replace("single@", "")
    }
    try {


      if (typeof id_ === "number") {
        id_ = selectedLayout.temp[0].symbol
      }

      let data = JSON.parse(
        (JSON.parse(selectedLayout.content))[id_]
      );




      let content = (JSON.parse(data.content));
      if (!isDark) {

        content.charts[0].chartProperties.scalesProperties.textColor = "#ffffff"
        content.charts[0].chartProperties.paneProperties.background = "#0a1229"
        content.charts[0].chartProperties.paneProperties.horzGridProperties.color = "rgba(240, 243, 250, 0.06)"
        content.charts[0].chartProperties.paneProperties.vertGridProperties.color = "rgba(240, 243, 250, 0.06)"

      } else {

        content.charts[0].chartProperties.paneProperties.background = "#ffffff"
        content.charts[0].chartProperties.scalesProperties.textColor = "#000000"
        content.charts[0].chartProperties.paneProperties.horzGridProperties.color = "rgba(42, 46, 57, 0.06)"
        content.charts[0].chartProperties.paneProperties.vertGridProperties.color = "rgba(42, 46, 57, 0.06)"

      }

      data.content = JSON.stringify(content)
      data_ = JSON.stringify(data)
    } catch (err) {
      console.log(err)
    }

    return new Promise((resolve, reject) => {
      if (data_) {
        setAllTvWidgetsCompReady(false)
        resolve(data_);
      } else {
        reject('No layout found for the specified symbol.');
      }
    });
  }, [tvWidgetsCompReady, layouts, loadChart])

  const loadAllcharts = useCallback(async () => {
    if (tvWidgetsCompReady && !layouts[0]) {
      try {
        const response = await api.get("/chart/1.3/charts");

        if (response.data.data.length) {



          let i = 0;
          let layout_ = response.data.data[i];

          let content = JSON.parse(response.data.data[i].content);
          console.log("from LoadAllcharts", content);
          setLayouts(response.data.data);

          // toSaveData accumulates { [symbol]: chartContentJSON } across every
          // symbol the user has ever drawn on under this layout, but as a
          // plain useState it starts empty on every fresh page load. Without
          // seeding it here from what the server already has, the very next
          // autosave (saveChart() below, content: JSON.stringify(toSaveData))
          // would POST only the symbol(s) touched in *this* session, flatly
          // REPLACING the server's content column and silently wiping out
          // every other symbol's drawings saved in earlier sessions - exactly
          // why changes looked like they weren't being remembered.
          setToSaveData(content);
          setToSaveAllData({
            id: layout_.id,
            name: layout_.name,
            symbol: layout_.symbol,
            resolution: layout_.resolution,
            content: layout_.content,
          });

          let tempSymbols = [];
          let types = [];
          if (layout_?.temp?.length ?? 0) {

            layout_.temp.forEach((data, index) => {

              if (data && data.symbol) {
                tempSymbols.push(data.symbol);
                types.push(data.type ?? 1);

                setSymbolsID((prevSymbols) => {
                  const updatedArray = [...prevSymbols];
                  updatedArray[index] = `${index}@${data.symbol}`;
                  return updatedArray;
                });
              }

            });
            if (tempSymbols.length == 0) {
              setSymbols(["شستا"]);
              adjustedTypes.current = ([1]);
            } else {
              setSymbols(tempSymbols);
              adjustedTypes.current = (types);




            }
          } else {
            setSymbols(["فملی"]);
            adjustedTypes.current = ([1]);


          }
        } else {
          setSymbols(["فملی"]);
          adjustedTypes.current = ([1]);


          setIsScriptReady(true);

        }
      } catch (error) {
        console.error("Error loading chart data:", error);
      }

    }
  }, [tvWidgetsComp, tvWidgetsCompReady, layouts]);


  useEffect(() => {
    if (permittedToLoad) {
      loadAllcharts();

    }
  }, [tvWidgetsComp, tvWidgetsCompReady, permittedToLoad]);

  const getTemplates = useCallback(() => {
    if (layouts[0] && tvWidgetsCompReady && symbols[0]) {
      if (isFirstTemplateLoad) {

        let layout = layouts[0]
        const tv_temps = layout?.tv_temps;

        setLoadedChart(layout.name)

        if (tv_temps?.length ?? 0) {
          tv_temps.sort();
          setWidgets((prevWidgets) => {
            const updatedWidgets = tv_temps;
            return updatedWidgets;
          });
          const temp_pos = layout?.temp_pos;
          setWidgetPos(temp_pos ?? 1)
        }
        setIsFirstTemplateLoad(false);
        setIsScriptReady(true);
      }

    }
  }, [tvWidgetsComp, tvWidgetsCompReady, layouts, isFirstTemplateLoad]);



  useEffect(() => {
    if (tvWidgetsCompReady && layouts[0]) {
      getTemplates();
    }

  }, [tvWidgetsComp, tvWidgetsCompReady, layouts, isFirstTemplateLoad]);
  useEffect(() => {

    if (allTvWidgetsCompReady && selectedChart >= 0) {

      Cookies.set('selectedChart', selectedChart, {
        secure: true,
        sameSite: 'strict',
        expires: 7000,
        path: '/',
      });

      try {

        tvWidgetsComp[selectedChart].onChartReady(() => {



          console.log("onChartReady openSaveDialogSignal setInterval selectedChart", selectedChart)
          const s_type = adjustedTypes.current[selectedChart]
          setAdjustedType(s_type);
          setAdjustedText(s_type == 1 ? "تعدیل شده" : "تعدیل نشده");
          setMainWidget(tvWidgetsComp[selectedChart]);
          setSelectedInterval(tvWidgetsComp[selectedChart].activeChart().resolution());
          setSelectedBar(tvWidgetsComp[selectedChart].activeChart().chartType());
          setSelectedBar(tvWidgetsComp[selectedChart].activeChart().chartType());
          setCurrentSymbol(tvWidgetsComp[selectedChart].activeChart().symbolExt().symbol);

          setTemplateLoaded(true)
        })
      } catch (e) {
        //console.log("allTvWidgetsCompReady", e)
      }

    }

  }, [selectedChart, allTvWidgetsCompReady, tvWidgetsComp])
  useEffect(() => {
    let interval = setInterval(() => {
      if (tvWidgetsCompReady && selectedChart >= 0) {

        let readyCount = 0;
        try {
          for (let index = 0; index < tvWidgetsComp.length; index++) {
            const item = tvWidgetsComp[index];

            if (item?.activeChart()?.symbolExt().symbol) {
              readyCount++;
            }
          }

          if (readyCount == tvWidgetsComp.length) {
            setAllTvWidgetsCompReady(true);

            clearInterval(interval)
          }

        } catch (e) {
        }

      }
    }, 500);
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }

  }, [tvWidgetsComp, tvWidgetsCompReady])

  useEffect(() => {




    if (mainWidget != null && replayMode) {

      console.log("replay")



      mainWidget.remove();


      let tv_widget = window.chart = (new widget({
        symbol: `${replaySymbol}`,
        debug: "false",
        locale: "fa",
        timezone: "Asia/Tehran",
        container: "tv" + (parseInt(selectedChart) + 1),
        theme: isDark ? "Light" : "Dark",
        width: "100%",
        symbol_search_request_delay: 1000,
        custom_css_url: "/static/charting_library/custom.css",
        height: "100%",
        //auto_save_delay: 10,
        datafeed: customDatafeed,
        enabled_features: ["custom_resolutions", "study_templates", "side_toolbar_in_fullscreen_mode", "display_legend_on_all_charts"],
        library_path: "/static/charting_library/",
        custom_formatters: {
          dateFormatter: {
            format: (date) => {
              moment.locale('fa');
              return moment(date).format('dddd') + ', ' + moment(date).format('jYYYY/jM/jD');
            },
          },

          tickMarkFormatter: (date, tickMarkType) => {
            switch (tickMarkType) {
              case 'Year':
                return moment(date).format('jYYYY');

              case 'Month':
                return jMonths[moment(date).format('jM') - 1];


              case 'DayOfMonth':
                return moment(date).format('jD');

              case 'Time':
                return date.getUTCHours() + ':' + date.getUTCMinutes();

              case 'TimeWithSeconds':
                return date.getUTCHours() + ':' + date.getUTCMinutes() + ':' + date.getUTCSeconds();
            }

            throw new Error('unhandled tick mark type ' + tickMarkType);
          }
        },

        custom_font_family: "dana",
        time_frames: [
          {
            text: "1Y",
            resolution: "12M"
          },
          {
            text: "6M",
            resolution: "6M"
          },
          {
            text: "3M",
            resolution: "3M"
          },
          {
            text: "1W",
            resolution: "W"
          },
          {
            text: "1D",
            resolution: "D"
          },
        ],


        disabled_features: ["header_fullscreen_button", "symbol_search_hot_key"
          ,
          "header_symbol_search",
          "header_widget"

          ,
          "create_volume_indicator_by_default"],
        // load_last_chart: true,
        save_load_adapter: {

          getAllCharts: async function () {

            try {

              return Promise.resolve(layouts);
            } catch (error) {
              console.error('Error loading all charts:', error);
            }
          },
          removeChart: async function (id) {

            try {
              const remove = await removeChart(id);
              return Promise.resolve();
            } catch (error) {
              return Promise.reject();

            }


          },
          getChartContent: async (id) => getChartContent(id),
          saveChart: (chartData) => {


            setToSaveAllData(chartData);
            setToSaveData((prevData) => ({
              ...prevData,
              [chartData.symbol]: chartData.content,
            }));

            if (allTvWidgetsCompReady) {

              setIsReadyToAutoSave(true)
              if (savePreBtnPressed) {
                setPreSaveBtnPressed(0);
                setSaveBtnPressed(1)

              }

            }


          }
        }





      }));

      setTvWidgetsCompReady(false)

      tv_widget.onChartReady(() => {


        let index = selectedChart
        let temp = [...tvWidgets];
        temp.push("tv" + (index + 1));
        temp.sort()
        setMainWidget(tv_widget);

        setTvWidgetsComp((prevSymbols) => {
          const updatedArray = [...prevSymbols];
          updatedArray[index] = tv_widget;
          return updatedArray;
        });


        if (isDark) {
          tv_widget.applyOverrides({
            "paneProperties.background": "#ffffff",
            "paneProperties.backgroundType": "solid",
            "scalesProperties.textColor": "#0a1229"

          })
        } else {
          tv_widget.applyOverrides({
            "paneProperties.background": "#0a1229",
            "paneProperties.backgroundType": "solid",
            "scalesProperties.textColor": "#0a1229"

          })

        }

        tv_widget.activeChart().onDataLoaded().subscribe(null, () => {




          try {
            let symbol = tv_widget.activeChart().symbolExt().symbol;

            if (symbol) {
              tv_widget.loadChartFromServer({
                id: `single@${symbol}`,
              });
            }

          } catch (e) {
            console.log(e)
          }

        }, true);

        tv_widget.activeChart().onDataLoaded().subscribe(null, () => {
          console.log("replay onDataLoaded")
          setTvWidgetsCompReady(true)


        }, false);
      })
    }
  }, [replayMode])






  useEffect(() => {



    if (isScriptReady && Object.keys(allMarketWatcher).length && layouts) {


      widgets.map((item, index) => {
        const elementId = `tv${index + 1}`;



        if (!iframeExists[elementId]) {






          let toBeShown = symbols[index];
          let allList = allMarketWatcher.map(item => item.items).flat().filter(item => item.type == "bourse");


          console.log("toBeShown", toBeShown)
          if (!toBeShown) {
            toBeShown = allList[Math.floor(Math.random() * allList.length)].tv_code;

          }
          else if (toBeShown == currentSymbol && index > 0) {
            toBeShown = allList[Math.floor(Math.random() * allList.length)].tv_code;
          }

          let tv_widget = new widget({
            symbol: `${toBeShown ?? currentSymbol}`,
            locale: "fa",

            debug: "false",
            timezone: "Asia/Tehran",
            container: `tv${index + 1}`,
            theme: isDark ? "Light" : "Dark",
            width: "100%",
            symbol_search_request_delay: 1000,
            custom_css_url: "/static/charting_library/custom.css",
            custom_font_family: "IRANSans",
            height: "100%",
            auto_save_delay: 3,
            datafeed: customDatafeed,
            enabled_features: ["custom_resolutions", "study_templates", "side_toolbar_in_fullscreen_mode", "display_legend_on_all_charts"],
            library_path: "/static/charting_library/",
            custom_font_family: "dana",
            time_frames: [
              {
                text: "1Y",
                resolution: "12M"
              },
              {
                text: "6M",
                resolution: "6M"
              },
              {
                text: "3M",
                resolution: "3M"
              },
              {
                text: "1W",
                resolution: "W"
              },
              {
                text: "1D",
                resolution: "D"
              },
            ],
            custom_formatters: {
              dateFormatter: {
                format: (date) => {
                  moment.locale('fa');
                  return moment(date).format('dddd') + ', ' + moment(date).format('jYYYY/jM/jD');
                },
              },

              tickMarkFormatter: (date, tickMarkType) => {
                switch (tickMarkType) {
                  case 'Year':
                    return moment(date).format('jYYYY');

                  case 'Month':
                    return jMonths[moment(date).format('jM') - 1];


                  case 'DayOfMonth':
                    return moment(date).format('jD');

                  case 'Time':
                    return date.getUTCHours() + ':' + date.getUTCMinutes();

                  case 'TimeWithSeconds':
                    return date.getUTCHours() + ':' + date.getUTCMinutes() + ':' + date.getUTCSeconds();
                }

                throw new Error('unhandled tick mark type ' + tickMarkType);
              }
            },
            disabled_features: ["header_fullscreen_button", "symbol_search_hot_key"
              ,
              "header_symbol_search",
              "header_widget"

              ,
              "create_volume_indicator_by_default"],
            // load_last_chart: true,
            save_load_adapter: {

              getAllCharts: async function () {

                try {

                  return Promise.resolve(layouts);
                } catch (error) {
                  console.error('Error loading all charts:', error);
                }
              },
              removeChart: async function (id) {

                try {
                  const remove = await removeChart(id);
                  return Promise.resolve();
                } catch (error) {
                  return Promise.reject();

                }


              },
              getChartContent: async (id) => getChartContent(id),
              saveChart: (chartData) => {


                setToSaveAllData(chartData);
                setToSaveData((prevData) => ({
                  ...prevData,
                  [chartData.symbol]: chartData.content,
                }));

                if (allTvWidgetsCompReady) {

                  setIsReadyToAutoSave(true)
                  if (savePreBtnPressed) {
                    setPreSaveBtnPressed(0);
                    setSaveBtnPressed(1)

                  }

                }


              }
            }



          });















          tv_widget.onChartReady(() => {


            let temp = [...tvWidgets];
            temp.push("tv" + (index + 1));
            temp.sort()
            setTvWidgets(temp);

            setTvWidgetsCompReady(false)
            setTvWidgetsComp((prevSymbols) => {
              const updatedArray = [...prevSymbols];
              updatedArray[index] = tv_widget;
              return updatedArray;
            });





            if (isDark) {
              tv_widget.applyOverrides({
                "paneProperties.background": "#ffffff",
                "paneProperties.backgroundType": "solid",
                "scalesProperties.textColor": "#0a1229"

              })
            } else {
              tv_widget.applyOverrides({
                "paneProperties.background": "#0a1229",
                "paneProperties.backgroundType": "solid",
                "scalesProperties.textColor": "#0a1229"

              })

            }

            tv_widget.activeChart().onDataLoaded().subscribe(null, () => {

              setTimeout(() => {
                try {
                  if (autoSaveConf) {
                    tv_widget.saveChartToServer(null, null, { chartName: "$autoSave$" + loadedChart });
                  }
                } catch (e) { }
              }, autoSaveDelay)



              try {
                let symbol = tv_widget.activeChart().symbolExt().symbol;

                if (symbol) {
                  tv_widget.loadChartFromServer({
                    id: `single@${symbol}`,
                  });
                }

              } catch (e) {
                console.log(e)
              }

            }, true);



            tv_widget.subscribe("onAutoSaveNeeded", () => {

              if (!replayMode) {
                console.log("onAutoSaveNeeded called")


                tv_widget.saveChartToServer(null, null, { chartName: loadedChart });



              }

            });


          });





        }




      });

    }

    setTvWidgetsCompReady(true)


  }, [tvWidgets, widgets, isScriptReady, symbols, iframeExists, allMarketWatcher, layouts]);





  const observersRef = useRef({});

  useEffect(() => {
    if (typeof document === 'undefined') return;

    // Function to clean up observers for widgets that are no longer present
    const cleanupObservers = (currentWidgets) => {
      Object.keys(observersRef.current).forEach((widgetId) => {
        if (!currentWidgets.includes(widgetId)) {
          observersRef.current[widgetId].disconnect();
          delete observersRef.current[widgetId];
        }
      });
    };

    // Clean up observers for removed widgets
    cleanupObservers(widgets);

    // Update iframeExists state to include only current widgets
    setIframeExists((prev) => {
      const updatedState = {};
      widgets.forEach((widgetId) => {
        // Preserve existing state for existing widgets
        if (prev.hasOwnProperty(widgetId)) {
          updatedState[widgetId] = prev[widgetId];
        } else {
          updatedState[widgetId] = false;
        }
      });
      return updatedState;
    });

    widgets.forEach((widgetId) => {
      // Avoid setting up multiple observers for the same widget
      if (observersRef.current[widgetId]) return;

      const tvElement = document.getElementById(widgetId);

      if (!tvElement) {
        // If the element doesn't exist, ensure iframeExists is false
        setIframeExists((prev) => ({
          ...prev,
          [widgetId]: false,
        }));
        return;
      }

      // Function to check if iframe exists within the tvElement
      const checkIframe = () => {
        const iframe = tvElement.querySelector('iframe');
        setIframeExists((prev) => ({
          ...prev,
          [widgetId]: !!iframe,
        }));
      };

      // Initial check
      checkIframe();

      // Create a MutationObserver for the current tvElement
      const observer = new MutationObserver(checkIframe);

      // Start observing for changes in the child list and subtree
      observer.observe(tvElement, { childList: true, subtree: true });

      // Store the observer in the ref for later cleanup
      observersRef.current[widgetId] = observer;
    });

    // Cleanup function to disconnect observers for widgets that are removed
    return () => {
      cleanupObservers(widgets);
    };
  }, [widgets]);

  const iframeHandlersRef = useRef(new Map());

  // Ref to store the latest replayMode
  const replayModeRef = useRef(replayMode);

  useEffect(() => {
    replayModeRef.current = replayMode;
  }, [replayMode]);

  const handleClick = useCallback((index_) => {

    if (index_ != selectedChart) {

      if (replayModeRef.current) {
        toast.error(t("Exit replay mode to select other charts"));
      } else {
        setSelectedChart(parseInt(index_));
      }
    }

  }, [selectedChart, setSelectedChart, t]);

  useEffect(() => {
    if (!tvWidgetsCompReady) return;

    widgets.forEach((item, index) => {
      const iframe = document.querySelector(`#${item} iframe`);
      if (iframe && tvWidgetsComp[index]) {
        try {

          const existingHandler = iframeHandlersRef.current.get(iframe);
          if (existingHandler) {
            iframe.contentDocument.removeEventListener('click', existingHandler);
          }

          const handler = () => handleClick(index);

          iframe.contentDocument.addEventListener('click', handler);

          iframeHandlersRef.current.set(iframe, handler);
        } catch (error) {
          console.warn('Unable to access iframe content:', error);
        }
      }
    });

    // Cleanup function to remove all event listeners when dependencies change or component unmounts
    return () => {
      const iframes = document.querySelectorAll('iframe');
      iframes.forEach((iframe) => {
        const handler = iframeHandlersRef.current.get(iframe);
        if (handler) {
          try {
            iframe.contentDocument.removeEventListener('click', handler);
          } catch (error) {
            console.warn('Unable to remove event listener from iframe content:', error);
          }
          // Remove the handler from the map
          iframeHandlersRef.current.delete(iframe);
        }
      });
    };
  }, [tvWidgetsCompReady, widgets, tvWidgetsComp, handleClick]);







  const widgetsTemp = widgets.map((item, index) => (

    <div
      key={index}
      id={`chart-${index + 1}`}
      style={{ gridArea: `chart-${index + 1}` }}
      className={` h-full border-2 ${selectedChart == index && widgets.length !== 1 ? 'border-chart' : ''}`}
      ref={(el) => (container.current[index] = el)}
    >
      <div className="relative h-full">
        <div
          key={index}
          className={"tradingview-widget-container__widget  h-full TVChartContainer"
          }
          id={item}
        ></div>
      </div>
    </div>
  ));
  return (





    <section id="chart-content" className={`flex flex-col relative   ${styles.mw__pane__1} h-full ${!watcherOpen ? '!w-full' : ''}`}>

      <section id="height-chart" className="flex items-center relative border-b-2 z-10 test-md overflow-x-auto" style={{ height: "40px" }}>
        <div id="nav-bar" className="h-full w-full flex justify-between items-center border-color text-tt-content" dir="ltr">



          <div className="flex items-center h-full" dir="rtl">



            <div className="replay-btn box-button w-max  items-center h-full border-r-2" style={{ display: 'none' }} ref={exit_replay_mode}
              onClick={() => { exitReplayMode() }}>
              <button className="flex items-center justify-between pr-2 cursor-pointer h-full py-1 px-2 w-max btn-grey-hover" >
                <span className="mt-0.5 ml-2">خروج از پخش</span>
              </button>
            </div>


            <div className="replay-btn box-button w-max hidden md:flex  items-center h-full border-x-2" ref={bar_replay} onClick={() => { startReplayMode() }}>
              <button className="flex items-center justify-between pr-2 cursor-pointer h-full py-1 px-2 w-max btn-grey-hover" >
                <span className="mt-0.5 ml-2">حالت پخش</span>
                <div ref={playOrStop} >
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" className="w-6 h-6"><path fill="none" stroke="currentColor" d="M13.5 20V9l-6 5.5 6 5.5zM21.5 20V9l-6 5.5 6 5.5z"></path></svg>
                </div>
              </button>
            </div>





            <div className="speed-btn header-box relative h-full" style={{ display: 'none' }} ref={bar_replay_speed}>
              <div className="flex h-full cursor-pointer" onClick={() => {
                setShowSelectSpeed(!showSelectSpeed);
              }}>
                <div className="box-button flex items-center h-full py-1 px-2 border-l-2"  >

                  <div>{selectedReplaySpeed}</div>





                </div>

              </div>
              <div className={`fixed ${showSelectSpeed ? "" : "hidden"}`}>
                <div className={styles.dropdownItem}>
                  <div className="content flex flex-col items-center ">
                    <ul className="flex flex-col divide-y z-10 divide-gray-600">

                      <li className="flex items-center text-left p-3 box-icon cursor-pointer btn-grey-hover"
                        onClick={(e) => {
                          setShowSelectSpeed(!showSelectSpeed);
                          setSelectedReplaySpeed("1x");

                        }}>
                        <div className="flex flex-row items-center">

                          1x
                        </div>
                      </li>


                      <li className="flex items-center text-left p-3 box-icon cursor-pointer btn-grey-hover"
                        onClick={(e) => {
                          setShowSelectSpeed(!showSelectSpeed);
                          setSelectedReplaySpeed("10x");

                        }}>
                        <div className="flex flex-row items-center">

                          10x
                        </div>
                      </li>
                      <li className="flex items-center text-left p-3 box-icon cursor-pointer btn-grey-hover"
                        onClick={(e) => {
                          setShowSelectSpeed(!showSelectSpeed);
                          setSelectedReplaySpeed("100x");

                        }}>
                        <div className="flex flex-row items-center">

                          100x
                        </div>
                      </li>


                    </ul>
                  </div>
                </div>
              </div>

            </div>

            <div className=" box-button w-max  items-center h-full border-l-2" style={{ display: 'none' }} ref={bar_replay_step}>
              <button className="flex items-center justify-between py-1 px-2 cursor-pointer h-full w-max btn-grey-hover" >
                <div ref={bar_replay_step_state} className="w-4 h-4">

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="currentColor" width="28" height="28"><path fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path></svg>
                </div></button></div>




            <div className=" box-button w-max  items-center h-full border-l-2" style={{ display: 'none' }} ref={bar_replay_controls}>
              <button className="flex items-center justify-between px-2 cursor-pointer h-full py-1 px-2 w-max btn-grey-hover" >
                <div ref={bar_replay_controls_state} className="w-4 h-4">

                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="currentColor" width="28" height="28"><path fillRule="nonzero" d="M6 14.774L12.498 9 6 3.226v11.548zM5 17V1l9.004 8L5 17z"></path></svg>
                </div></button></div>





            <div className="box-button flex items-center h-full border-l-1">
              <button className="outline-0 flex items-center h-full py-1 px-2 pr-2 pl-1 cursor-pointer btn-grey-hover" onClick={indicatorTV} ><span className="ml-2 hidden md:block">اندیکاتورها</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" fill="none" className="w-6 h-6"><path stroke="currentColor" d="M6 12l4.8-4.8a1 1 0 0 1 1.4 0l2.7 2.7a1 1 0 0 0 1.3.1L23 5"></path><path fill="currentColor" fillRule="evenodd" d="M19 12a1 1 0 0 0-1 1v4h-3v-1a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v2H7a1 1 0 0 0-1 1v4h17V13a1 1 0 0 0-1-1h-3zm0 10h3v-9h-3v9zm-1 0v-4h-3v4h3zm-4-4.5V22h-3v-6h3v1.5zM10 22v-3H7v3h3z"></path></svg></button></div> <div className="box-button flex items-center h-full border-l-2">
              <button className="outline-0 hidden md:flex items-center h-full py-1 px-2 cursor-pointer btn-grey-hover" onClick={compareTV} >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" className="w-6 h-6"><path fill="currentColor" d="M13.5 6a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17zM4 14.5a9.5 9.5 0 1 1 19 0 9.5 9.5 0 0 1-19 0z"></path> <path fill="currentColor" d="M9 14h4v-4h1v4h4v1h-4v4h-1v-4H9v-1z"></path></svg></button>



            </div>











            <div className="header-box relative h-full " ref={candleDP} >
              <div className="box-button flex items-center h-full border-l-2  w-max" onClick={() => { setShowSelectCandle(!showSelectCandle) }}>
                <div className="flex items-center h-full py-1 px-2  btn-grey-hover cursor-pointer">
                  <span className="font-bold" dangerouslySetInnerHTML={
                    { __html: barTypeActiveIcon }
                  }></span>
                  <span className='hidden md:block'>{tvCandleTypes[selectedBar]}</span>
                </div>
              </div>
              <div className={`fixed ${showSelectCandle ? "" : "hidden"}`} dir="rtl">
                <div className={styles.dropdownItem} >
                  <div className="content flex flex-col items-center ">
                    <ul className="flex flex-col divide-y z-10 divide-gray-600">



                      {tvCandleTypes.map((item, i) => <li className="flex items-center text-left p-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={(e) => {
                          setShowSelectCandle(!showSelectCandle); setSelectedBar(i); mainWidget.activeChart().setChartType(i)
                          setBarTypeActiveIcon(e.currentTarget.querySelector("svg").outerHTML)
                        }}>
                        <div className="flex flex-row items-center">

                          <span className="pl-1"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" className="w-6 h-6"><g fill="none" stroke="currentColor" strokeLinecap="square"><path d="M10.5 7.5v15M7.5 20.5H10M13.5 11.5H11M19.5 6.5v15M16.5 9.5H19M22.5 16.5H20"></path></g></svg></span>
                          <span>
                            {item}
                          </span>
                        </div>
                      </li>)}






                    </ul>
                  </div>
                </div>
              </div>
            </div>




            <div className={`header-box relative h-full ${replayMode ? "disabled" : ""}`} ref={timeFrameDP} >
              <div className="box-button flex items-center h-full  w-max"


                onClick={() => { setShowSelectInterval(!showSelectInterval) }}>
                <div className="flex items-center h-full py-1 px-2 btn-grey-hover cursor-pointer">
                  <span className="font-bold">{barIntervals[selectedInterval]}</span>
                </div>
              </div>
              <div

                className={`fixed ${showSelectInterval ? "" : "hidden"}`}><div className={styles.dropdownItem}>
                  <div className="content flex flex-col items-center " dir="rtl">
                    <ul className="flex flex-col divide-y z-10 divide-gray-600">

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("1"); mainWidget.activeChart().setResolution(1); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            1 دقیقه
                          </span>

                        </div>
                      </li>

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("5"); mainWidget.activeChart().setResolution("5"); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            5 دقیقه
                          </span>

                        </div>
                      </li>

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("60"); mainWidget.activeChart().setResolution("60"); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            1 ساعت
                          </span>

                        </div>
                      </li>


                      {/* <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("240"); mainWidget.activeChart().setResolution("240"); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            4 ساعت
                          </span>

                        </div>
                      </li> */}

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("1D"); mainWidget.activeChart().setResolution("1D"); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            1 روز
                          </span>

                        </div>
                      </li>

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => { setShowSelectInterval(!showSelectInterval); setSelectedInterval("1W"); mainWidget.activeChart().setResolution("1W"); setReplayMode(false) }}>
                        <div className="flex flex-row">
                          <span>
                            1 هفته
                          </span>

                        </div>
                      </li>


                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => {
                          setShowSelectInterval(!showSelectInterval); setSelectedInterval("1M");
                          mainWidget.activeChart().setResolution("1M"); setReplayMode(false)
                        }}>
                        <div className="flex flex-row">
                          <span>
                            1 ماهه
                          </span>

                        </div>
                      </li>

                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => {
                          setShowSelectInterval(!showSelectInterval); setSelectedInterval("3M");
                          mainWidget.activeChart().setResolution("3M"); setReplayMode(false)
                        }}>
                        <div className="flex flex-row">
                          <span>
                            3 ماهه
                          </span>

                        </div>
                      </li>



                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => {
                          setShowSelectInterval(!showSelectInterval); setSelectedInterval("6M");
                          mainWidget.activeChart().setResolution("6M"); setReplayMode(false)
                        }}>
                        <div className="flex flex-row">
                          <span>
                            6 ماهه
                          </span>

                        </div>
                      </li>



                      <li className="flex items-center text-left px-4 py-1 box-icon cursor-pointer btn-grey-hover"
                        onClick={() => {
                          setShowSelectInterval(!showSelectInterval); setSelectedInterval("12M");
                          mainWidget.activeChart().setResolution("12M"); setReplayMode(false)
                        }}>
                        <div className="flex flex-row">
                          <span>
                            یک ساله
                          </span>

                        </div>
                      </li>


                    </ul>
                  </div>
                </div>
              </div>
            </div>



            {/* 
          <button className="outline-0 flex items-center h-full p-2 cursor-pointer btn-grey-hover" onClick={searchTV} >
            {currentSymbol}

          </button> */}
          </div>
          <div className="flex items-center h-full" dir="rtl">


            <div className="box-button flex md:hidden items-center h-full border-l-2" onClick={openPhoneMenu}>
              <button className="outline-0 p-2 h-full cursor-pointer btn-grey-hover" >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="28" height="28" fill="currentColor" className="w-6 h-6">
                  <path d="M4 6h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2zm0 6h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2zm0 6h16a1 1 0 1 0 0-2H4a1 1 0 1 0 0 2z"></path>
                </svg>
              </button>
            </div>

            <div className="header-box relative h-full hidden md:block" onClick={toggleFullscreen}>
              <div id="btn-fullscreen" className="box-button flex items-center h-full">
                <button className="header-box  btn-grey-hover px-2 py-1 cursor-pointer h-full w-max" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" className="w-6 h-6"><path fill="currentColor" d="M8.5 6A2.5 2.5 0 0 0 6 8.5V11h1V8.5C7 7.67 7.67 7 8.5 7H11V6H8.5zM6 17v2.5A2.5 2.5 0 0 0 8.5 22H11v-1H8.5A1.5 1.5 0 0 1 7 19.5V17H6zM19.5 7H17V6h2.5A2.5 2.5 0 0 1 22 8.5V11h-1V8.5c0-.83-.67-1.5-1.5-1.5zM22 19.5V17h-1v2.5c0 .83-.67 1.5-1.5 1.5H17v1h2.5a2.5 2.5 0 0 0 2.5-2.5z"></path></svg></button></div> <div id="fullscreen" className="fixed w-max"></div></div> <div className="header-box relative h-full"><div id="btn-settings" className="box-button flex items-center h-full border-l-1">
                  <button className="p-2 cursor-pointer h-full w-max  btn-grey-hover" onClick={settingTV} >

                    <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 outline-0 relative z-10 " viewBox="0 0 28 28" width="28" height="28" >
                      <g fill="currentColor" fillRule="evenodd"><path fillRule="nonzero" d="M14 17a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"></path>
                        <path d="M5.005 16A1.003 1.003 0 0 1 4 14.992v-1.984A.998.998 0 0 1 5 12h1.252a7.87 7.87 0 0 1 .853-2.06l-.919-.925c-.356-.397-.348-1 .03-1.379l1.42-1.42a1 1 0 0 1 1.416.007l.889.882A7.96 7.96 0 0 1 12 6.253V5c0-.514.46-1 1-1h2c.557 0 1 .44 1 1v1.253a7.96 7.96 0 0 1 2.06.852l.888-.882a1 1 0 0 1 1.416-.006l1.42 1.42a.999.999 0 0 1 .029 1.377s-.4.406-.918.926a7.87 7.87 0 0 1 .853 2.06H23c.557 0 1 .447 1 1.008v1.984A.998.998 0 0 1 23 16h-1.252a7.87 7.87 0 0 1-.853 2.06l.882.888a1 1 0 0 1 .006 1.416l-1.42 1.42a1 1 0 0 1-1.415-.007l-.889-.882a7.96 7.96 0 0 1-2.059.852v1.248c0 .56-.45 1.005-1.008 1.005h-1.984A1.004 1.004 0 0 1 12 22.995v-1.248a7.96 7.96 0 0 1-2.06-.852l-.888.882a1 1 0 0 1-1.416.006l-1.42-1.42a1 1 0 0 1 .007-1.415l.882-.888A7.87 7.87 0 0 1 6.252 16H5.005zm3.378-6.193l-.227.34A6.884 6.884 0 0 0 7.14 12.6l-.082.4H5.005C5.002 13 5 13.664 5 14.992c0 .005.686.008 2.058.008l.082.4c.18.883.52 1.71 1.016 2.453l.227.34-1.45 1.46c-.004.003.466.477 1.41 1.422l1.464-1.458.34.227a6.959 6.959 0 0 0 2.454 1.016l.399.083v2.052c0 .003.664.005 1.992.005.005 0 .008-.686.008-2.057l.399-.083a6.959 6.959 0 0 0 2.454-1.016l.34-.227 1.46 1.45c.003.004.477-.466 1.422-1.41l-1.458-1.464.227-.34A6.884 6.884 0 0 0 20.86 15.4l.082-.4h2.053c.003 0 .005-.664.005-1.992 0-.005-.686-.008-2.058-.008l-.082-.4a6.884 6.884 0 0 0-1.016-2.453l-.227-.34 1.376-1.384.081-.082-1.416-1.416-1.465 1.458-.34-.227a6.959 6.959 0 0 0-2.454-1.016L15 7.057V5c0-.003-.664-.003-1.992 0-.005 0-.008.686-.008 2.057l-.399.083a6.959 6.959 0 0 0-2.454 1.016l-.34.227-1.46-1.45c-.003-.004-.477.466-1.421 1.408l1.457 1.466z"></path></g></svg>
                  </button></div>
              <div id="settings" className="fixed w-max"></div>
            </div>

            <div className="box-button  items-center h-full hidden md:flex" onClick={redoTV}><button className="outline-0 p-2 h-full cursor-pointer btn-grey-hover" >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="28" height="28" className="w-6 h-6"><path fill="currentColor" d="M18.293 13l-2.647 2.646.707.708 3.854-3.854-3.854-3.854-.707.708L18.293 12H12.5A5.5 5.5 0 0 0 7 17.5V19h1v-1.5a4.5 4.5 0 0 1 4.5-4.5h5.793z"></path></svg></button></div>
            <div className="box-button hidden md:flex items-center h-full border-l-2" onClick={undoTV}>
              <button className="outline-0 p-2 h-full cursor-pointer btn-grey-hover" ><svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 28 28" width="28" height="28"><path fill="currentColor" d="M8.707 13l2.647 2.646-.707.708L6.792 12.5l3.853-3.854.708.708L8.707 12H14.5a5.5 5.5 0 0 1 5.5 5.5V19h-1v-1.5a4.5 4.5 0 0 0-4.5-4.5H8.707z"></path></svg></button>
            </div>





            <div className="header-box relative h-full " ref={multiCahrtDP} >
              <div id="btn-multi-chart" className="box-button flex items-center h-full border-l-2  w-max" onClick={() => { setShowMultiChart(!showMultiChart) }}>
                <div className="flex items-center h-full py-1 px-2 btn-grey-hover cursor-pointer" >
                  <div className="mr-3" dangerouslySetInnerHTML={
                    { __html: multiChartActiveIcon }
                  }>



                  </div>

                  <span className="font-normal hidden md:block">مولتی چارت</span>
                </div></div>


              <div className={`fixed ${showMultiChart ? "" : "hidden"}`} >
                <div className={styles.dropdownItem}>


                  <div className="content flex flex-col items-center p-2">
                    <ul className="flex flex-col divide-y z-10 divide-gray-600">

                      <li className="flex items-center text-right pb-1.5">

                        <div className="flex flex-row"><span className="box-icon cursor-pointer btn-grey-hover" onClick={(e) => {
                          multiChartAction(e, ["tv1"], 1)

                        }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" className="w-6 h-6">
                            <rect width="22" height="20" fill="none" stroke="currentColor" rx="2" transform="translate(.5 .5)"></rect>
                          </svg>

                        </span></div>


                      </li>
                      <li className="flex items-center text-right py-1.5"> <div className="flex flex-row">
                        <span className="box-icon cursor-pointer ml-1 btn-grey-hover"
                          onClick={(e) => {
                            multiChartAction(e, ["tv1", "tv2"], 2)


                          }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                            <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                              <rect width="22" height="20" rx="2"></rect>
                              <path d="M11 0v20"></path>
                            </g>
                          </svg>

                        </span> <span className="box-icon cursor-pointer ml-1 btn-grey-hover" onClick={(e) => {
                          multiChartAction(e, ["tv1", "tv2"], 3)

                        }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                            <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                              <rect width="22" height="20" rx="2"></rect>
                              <path d="M0 10h22"></path>
                            </g>
                          </svg>
                        </span></div></li>

                      <li className="flex items-center text-right py-1.5"> <div className="flex flex-row"><span className="box-icon cursor-pointer ml-1 btn-grey-hover"
                        onClick={(e) => {
                          multiChartAction(e, ["tv1", "tv2", "tv3"], 4)
                        }}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                          <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                            <rect width="22" height="20" rx="2"></rect>
                            <path d="M0 7h22M0 13h22"></path>
                          </g>
                        </svg>
                      </span> <span className="box-icon cursor-pointer ml-1 btn-grey-hover" onClick={(e) => { multiChartAction(e, ["tv1", "tv2", "tv3"], 5) }}
                      >

                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                            <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                              <rect width="22" height="20" rx="2"></rect>
                              <path d="M7 0v20M15 0v20"></path>
                            </g>
                          </svg>

                        </span> <span className="box-icon cursor-pointer ml-1 btn-grey-hover" onClick={(e) => { multiChartAction(e, ["tv1", "tv2", "tv3"], 6) }}
                        >

                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                            <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                              <rect width="22" height="20" rx="2"></rect>
                              <path d="M11 0v20M11 10h11"></path>
                            </g>
                          </svg>

                        </span> <span className="box-icon cursor-pointer ml-1 btn-grey-hover" onClick={(e) => { multiChartAction(e, ["tv1", "tv2", "tv3"], 7) }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="23" className="w-6 h-6">
                            <g fill="none" stroke="currentColor" transform="translate(.5 .5)">
                              <rect width="22" height="20" rx="2"></rect>
                              <path d="M0 10h22M11 0v10"></path>
                            </g>
                          </svg>
                        </span>
                      </div>
                      </li>
                    </ul>

                  </div>
                </div>
              </div>
            </div>



            <div className="header-box relative h-full ">
              <div id="btn-multi-chart" className="box-button flex items-center h-full border-l-2  w-max" onClick={() => { setTheme(!isDark) }}>
                <div className="flex items-center h-full py-1 px-2 btn-grey-hover cursor-pointer" >
                  <div className="" >
                    <svg width="28" height="28" x="0" y="0" viewBox="0 0 48 48" ><g><path d="M12.1 12c.2.3.5.4.8.4.2 0 .4-.1.6-.2.4-.3.5-1 .2-1.4l-.6-.8c-.3-.4-.9-.5-1.4-.2-.4.3-.5 1-.2 1.4zM7 27.8l-1 .3c-.5.2-.8.7-.6 1.3.1.4.5.7 1 .7h.3l1-.3c.5-.2.8-.7.6-1.3-.2-.5-.8-.8-1.3-.7zM22.1 9.5c.6 0 1-.4 1-1v-1c0-.6-.4-1-1-1s-1 .4-1 1v1c0 .6.4 1 1 1zM6.1 19.9s1.2.4 1.3.4c.4 0 .8-.3 1-.7.2-.5-.1-1.1-.6-1.3l-1-.3c-.5-.2-1.1.1-1.3.6-.3.5 0 1.1.6 1.3zM12.1 36l-.6.8c-.3.4-.2 1.1.2 1.4.2.1.4.2.6.2.3 0 .6-.1.8-.4l.6-.8c.3-.4.2-1.1-.2-1.4-.4-.4-1-.3-1.4.2zM42.3 22.2c-.3-.2-.7-.3-1-.2-.9.3-1.9.5-2.9.3-3.2-.5-5.5-3.5-5-6.7.2-1.2.7-2.3 1.6-3.2.3-.3.3-.7.2-1-.1-.4-.5-.6-1-.7-2.4-.4-4.8.2-6.8 1.4-1.6-.7-3.4-1.1-5.2-1.1-7.2-.1-13.1 5.8-13.1 13S15 37.1 22.2 37.1c4.5 0 8.7-2.3 11.1-6.1 4.4-.2 8.3-3.3 9.4-7.8 0-.4-.1-.8-.4-1zM22.2 35.1c-6.1 0-11.1-5-11.1-11.1s5-11.1 11.1-11.1c1.2 0 2.3.2 3.4.5-1.6 1.5-2.6 3.5-3 5.8-.8 5.5 2.9 10.6 8.3 11.5-2.1 2.8-5.3 4.4-8.7 4.4zm9.3-6.2c-4.5-.7-7.6-4.8-7-9.3.6-4 3.9-6.9 7.8-7-.5.8-.8 1.8-.9 2.8-.6 4.3 2.4 8.3 6.7 9 .7.1 1.3.1 2 0-1.5 3.1-5 5-8.6 4.5zM32 36c-.3-.4-.9-.5-1.4-.2-.4.3-.5 1-.2 1.4l.6.8c.2.3.5.4.8.4.2 0 .4-.1.6-.2.4-.3.5-1 .2-1.4zM22.1 38.5c-.6 0-1 .4-1 1v1c0 .6.4 1 1 1s1-.4 1-1v-1c0-.6-.5-1-1-1z" fill="currentColor" opacity="1" ></path></g></svg>


                  </div>

                </div>
              </div>



            </div>

            <div className="header-box relative h-full "  >
              <div id="export-chart" className="box-button flex items-center h-full border-l-2  w-max" onClick={exportExcel}>
                <div className="flex items-center h-full p-2 btn-grey-hover cursor-pointer" >
                  <svg fill={!isDark ? "white" : "black"} width="28px" height="28px" viewBox="0 0 256 256" id="Flat" xmlns="http://www.w3.org/2000/svg"><path d="M83.17139,60.81738a4.00059,4.00059,0,0,1,.00048-5.65722l42-41.98926a4.00207,4.00207,0,0,1,5.65625,0l42,41.98926a4.00026,4.00026,0,0,1-5.65625,5.6582L132,25.65527V128a4,4,0,0,1-8,0V25.65527L88.82812,60.81836A4.00089,4.00089,0,0,1,83.17139,60.81738ZM200,92H176a4,4,0,0,0,0,8h24a4.00427,4.00427,0,0,1,4,4V208a4.00427,4.00427,0,0,1-4,4H56a4.00427,4.00427,0,0,1-4-4V104a4.00427,4.00427,0,0,1,4-4H80a4,4,0,0,0,0-8H56a12.01343,12.01343,0,0,0-12,12V208a12.01343,12.01343,0,0,0,12,12H200a12.01343,12.01343,0,0,0,12-12V104A12.01343,12.01343,0,0,0,200,92Z" /></svg>

                </div>
              </div>
            </div>


            <div className="header-box relative h-full " ref={saveCahrtDP} >
              <div id="btn-save-chart" className="box-button flex items-center h-full border-l-2  w-max" onClick={() => {
                setShowSaveChart(!showSaveChart);


              }}>
                <div className="flex items-center h-full p-2 btn-grey-hover cursor-pointer" >
                  <svg ref={uploadTemp} xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" className="mr-2">
                    <g fill="none"><path stroke="currentColor" strokeDasharray="3.5,2.5" d="M21.5 21.5h-14a5 5 0 1 1 .42-9.983 7.5 7.5 0 0 1 14.57 2.106 4.002 4.002 0 0 1-.99 7.877z"></path> <path stroke="currentColor" strokeDasharray="49.866326904296876 13.08991081237793" strokeDashoffset="111.57590644836426" d="M21.5 21.5h-14a5 5 0 1 1 .42-9.983 7.5 7.5 0 0 1 14.57 2.106 4.002 4.002 0 0 1-.99 7.877z"></path> <path d="M11 20h6v5h-6z" >
                    </path> <g stroke="currentColor" ><path d="M14.5 14.5v10" strokeLinecap="square"></path> <path d="M11 17l3.5-3.5L18 17"></path></g> <g stroke="currentColor"><path strokeDasharray="0% 200%" d="M10 15l2.5 2.5L18 12"></path></g></g></svg>

                  <span className="font-normal hidden md:block">{loadedChart}</span>
                </div>
              </div>


              <div className={`fixed ${showSaveChart ? "" : "hidden"}`} >
                <div className={styles.dropdownItem}>


                  <div className="content flex flex-col items-center ">
                    <ul className="flex flex-col divide-y divide-gray-600 z-10" dir="rtl">
                      <li className="flex items-center text-right cursor-pointer btn-grey-hover" style={{ padding: `5px 15px` }} onClick={(e) => {

                        if (layouts[0]) {
                          saveChart(true)
                        } else {
                          setPreSaveBtnPressed(1);

                          setOpenSaveDialogSignal(true)
                        }

                        setShowSaveChart(!showSaveChart)
                      }}>
                        <div className="flex flex-row">
                          <span className="box-icon "
                          >ذخیره</span></div>
                      </li>


                      <li className="flex items-center text-right cursor-pointer btn-grey-hover" style={{ padding: `5px 15px` }} onClick={(e) => {

                        setPreSaveBtnPressed(1);
                        console.log("savePreBtnPressed", savePreBtnPressed)
                        setOpenSaveDialogSignal(true)


                        setShowSaveChart(!showSaveChart)
                      }}>
                        <div className="flex flex-row">
                          <span className="box-icon "
                          >ذخیره بعنوان</span></div>
                      </li>
                      <li className="flex items-center text-right cursor-pointer btn-grey-hover" style={{ padding: `5px 15px` }} onClick={(e) => {
                        mainWidget.showLoadChartDialog(); setShowSaveChart(!showSaveChart)



                      }}>  <div className="flex flex-row">
                          <span className="box-icon cursor-pointer ml-1 "

                          >

                            بارگذاری
                          </span>

                        </div></li>


                    </ul>

                  </div>
                </div>
              </div>
            </div>
            <div className="header-box relative h-full " ref={adjustedDP} >
              <div id="btn-adjust-chart" className="box-button flex items-center h-full border-l-2  w-max" onClick={() => {
                setShowAdjustedDP(!showAdjustedDP);


              }}>
                <div className="flex items-center h-full py-1 px-2 btn-grey-hover cursor-pointer" >


                  <span className="font-normal hidden md:block">{adjustedText}</span>
                </div></div>


              <div className={`fixed ${showAdjustedDP ? "" : "hidden"}`} >
                <div className={styles.dropdownItem}>


                  <div className="content flex flex-col items-center ">
                    <ul className="flex flex-col divide-y divide-gray-600 z-10">
                      <li className="flex items-center text-right cursor-pointer btn-grey-hover" style={{ padding: `5px 15px` }} onClick={(e) => {

                        changeAdjustedType(0)

                      }}>
                        <div className="flex flex-row">
                          <span className="box-icon">تعدیل نشده</span></div>
                      </li>


                      <li className="flex items-center text-right cursor-pointer btn-grey-hover" style={{ padding: `5px 15px` }} onClick={(e) => {
                        changeAdjustedType(1)


                      }}>
                        <div className="flex flex-row">
                          <span className="box-icon "
                          >تعدیل شده</span></div>
                      </li>



                    </ul>

                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
      </section>


      <div id="chart-screener" className=" overflow-hidden h-full">
        <div className="default-theme  h-full splitpanes splitpanes--horizontal">
          <div className="splitpanes__pane" style={{ height: 100 + '%' }}>
            <div id="parent-multi-chart" className={`parent-multi-chart  multi-chart-${widgetPos}  h-full text-tt-content `}>
              {widgetsTemp}
            </div>
          </div>
        </div>
      </div>
    </section>



  );
})

